import { Helmet } from 'react-helmet';

export const PageMeta = ({ title, children, ...props }) => {
	return (
		<Helmet {...props}>
			<title>{title}</title>
			{props.description && (
				<meta name="description" content={props.description} />
			)}
			<meta property="og:title" content={title} />
			{children}
		</Helmet>
	);
};
